/* src/app/umbrella-common/components/internal-documents/internal-documents.style.scss */
.header {
  display: flex;
  margin-top: 30px;
}
.header h6 {
  margin-top: 0;
  margin-bottom: 10px;
  margin-right: 20px;
  max-width: 299px;
  width: 299px;
  font-family: Arial, sans-serif;
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
  color: #007d40;
}
.documents {
  margin-bottom: 130px;
}
.documents .document {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  border-bottom: #e6e6e6 solid 1px;
  padding-bottom: 3px;
}
.documents .document .file-row {
  width: 275px;
  max-width: 275px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: inline-block;
}
.documents .document .document-name {
  font-weight: bold;
  font-family: Arial, sans-serif;
  font-size: 15px;
  line-height: 1.33;
  color: #585858;
}
.documents .document .created {
  margin-top: 3px;
  font-family: Arial, sans-serif;
  font-size: 12px;
  line-height: 1.33;
  color: #585858;
}
.documents .document .document-link {
  cursor: pointer;
  margin-right: 20px;
  color: #007d40;
  width: 25px;
  height: 25px;
}
.documents .document .delete-icon {
  cursor: pointer;
  margin-right: 10px;
  color: #ee7f00;
  width: 25px;
  height: 25px;
}
.upload-file {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 20px;
  margin-bottom: 10px;
}
.upload-file .input-file {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}
.upload-file .upload-file-button,
.upload-file .upload-file-button:focus {
  width: 130px;
  height: 32px;
  font-size: 12px;
  font-weight: bold;
  cursor: pointer;
  padding: 0.25rem 0.625rem;
  text-align: center;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
}
.upload-file .upload-file-button nb-icon,
.upload-file .upload-file-button:focus nb-icon {
  font-size: 14px;
}
/*# sourceMappingURL=internal-documents.style.css.map */
